import { AuiChartBase } from './AuiChartBase';
import type { AuiRendererProps } from '../../registry';

export function AuiBarChart(props: AuiRendererProps) {
  return <AuiChartBase {...props} testId="aui-bar-chart" />;
}
